import React from 'react'
import { Alert } from 'antd'
import { NotificationOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'

import { useAppSelector } from '../../store/hooks'
import { selectAuthCompanySlice } from '../../store/auth-company-slice'
import { roleAdmin } from '../../store/auth-user-slice'

import IntlMessages from '../../util/IntlMessages'

import { FrontendUrls } from '../../types/urls'

import '../../styles/components/trial-banner.less'

interface PastDueBannerProps {
  className?: string
  sidebarCollapsed?: boolean
}

const PastDueBanner: React.FC<PastDueBannerProps> = ({ className = '', sidebarCollapsed = false }) => {
  const { authCompany } = useAppSelector(selectAuthCompanySlice)
  const isAdmin = useAppSelector(roleAdmin)

  if (!isAdmin || authCompany?.subscriptionStatus !== 'past_due') {
    return null
  }

  return (
    <div className={`trial-banner ${sidebarCollapsed ? 'sidebar-collapsed' : 'sidebar-expanded'} ${className}`}>
      <Alert
        type="error"
        showIcon
        icon={<NotificationOutlined />}
        message={
          <IntlMessages
            id="app.pastDue"
            values={{
              // eslint-disable-next-line
              a: (...chunks) => <Link to={FrontendUrls.billing}>{chunks}</Link>,
            }}
          />
        }
        closable={false}
        className="trial-banner-alert"
        role="banner"
        aria-live="polite"
        aria-label="Past due payment banner"
      />
    </div>
  )
}

export default React.memo(PastDueBanner)
